export function getImageSrc(...sources: any[]): string | undefined {
  for (const source of sources) {
    if (!source) continue;

    if (typeof source === "string") {
      const trimmed = source.trim();
      if (!trimmed) continue;

      if (/^(https?:)?\/\//.test(trimmed) || trimmed.startsWith("data:")) {
        return trimmed;
      }

      const apiBase = process.env.REACT_APP_API_BASE?.replace(/\/$/, "");
      if (apiBase && trimmed.startsWith("/")) {
        return `${apiBase}${trimmed}`;
      }

      if (apiBase) {
        return `${apiBase}/${trimmed.replace(/^\//, "")}`;
      }

      return trimmed;
    }

    if (Array.isArray(source)) {
      const nested = getImageSrc(...source);
      if (nested) return nested;
      continue;
    }

    if (typeof source === "object") {
      const nested = getImageSrc(
        source.url,
        source.path,
        source.src,
        source.image,
        source.logo,
        source.cover,
      );

      if (nested) return nested;
    }
  }

  return undefined;
}
